import { runMigrations } from '@/store/utils/helpers'

export default function runRepositorySettingsMigrations(settings: Record<string, any>) {
  const migrations = (import.meta as any).glob('../migrations/*.ts', { eager: true })
  return runMigrations(settings, migrations)
}

export const orderTabs = (order: string[], key: string, index: number) => {
  const orderIndex = order.indexOf(key)
  if (orderIndex === -1) {
    return index
  }
  return orderIndex
}
